import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { justinfetchProductsStart } from './../../redux/Products/products.actions';
import Product from './JustInProduct';
import FormSelect from './../forms/FormSelect';
import LoadMore from './../LoadMore';
import ReactLoading from 'react-loading';
import Preloader from "./../Preloader1"
import './styles.scss';

const mapState = ({ productsData }) => ({
  justinproducts: productsData.products
});

var nf = new Intl.NumberFormat();

const Featured = ({ }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { justinvar } = useParams();
  const { justinproducts } = useSelector(mapState);

  const { data, queryDoc, isLastPage } = justinproducts;

  useEffect(() => {
    dispatch(
      justinfetchProductsStart({ justinvar })
    )
  }, [justinvar]);

  const [data2, setData] = useState([]);
  const [done, setDone] = useState(undefined);

  useEffect(() => {
    setTimeout(() => {
      fetch('https://jsonplaceholder.typicode.com/posts')
        .then(response =>{
          if(!response.ok){
            throw new Error(response.statusText)
          }else{
            (response.json())
            .then((json) => {
              console.log(json);
              setData(json);
              setDone(true);
            });
          }
          

        }).catch(err=>{
          console.log(err)
        })
    }, 500);

  }, [])


  if (!Array.isArray(data)) return null;
  if (data.length < 1) {
    return (
      <div className="products2">
        <Preloader />
      </div>
    );
  }

  return (

    <section className="cont">
      <>
        {
          !done ? <ReactLoading className="loader" type="bubbles" color={"rgb(245, 24, 153);"} height={100} width={100} />
            :
            (<div className="products2">

              <div className="productResults2">
                {data.map((justinproduct, pos) => {
                  const { image, pname, price } = justinproduct;
                  if (!image || !pname ||
                    typeof price === 'undefined') return null;

                  const configProduct = {
                    ...justinproduct
                  };

                  return (
                    <Product key={pos} {...configProduct} />
                  );
                })}
              </div>

              {/* {!isLastPage && (
              <LoadMore {...configLoadMore} />
            )} */}

            </div>)
        }
      </>
    </section>


  );
};

export default Featured;
